import type { SocialBlockLinkNetwork, SocialNetwork } from './types';

export const SOCIAL_PRESET_NETWORKS = [
  'facebook',
  'instagram',
  'twitter',
] as const satisfies readonly SocialNetwork[];

export type SocialPresetNetwork = (typeof SOCIAL_PRESET_NETWORKS)[number];

export const SOCIAL_LINK_DEFAULTS: Record<
  SocialNetwork,
  { title: string; alt: string; url: string }
> = {
  facebook: {
    title: 'Facebook',
    alt: 'Visit us on Facebook',
    url: 'https://www.facebook.com/',
  },
  instagram: {
    title: 'Instagram',
    alt: 'Visit us on Instagram',
    url: 'https://www.instagram.com/',
  },
  twitter: {
    title: 'Twitter',
    alt: 'Visit us on Twitter',
    url: 'https://www.twitter.com/',
  },
};

export const SOCIAL_STOCK_CATALOG_SLUG: Record<SocialNetwork, string> = {
  facebook: 'facebook',
  instagram: 'instagram',
  twitter: 'x',
};

export const CUSTOM_SOCIAL_LINK_DEFAULTS = {
  title: 'Custom',
  alt: 'Social link',
  url: '',
} as const;

export const MIN_SOCIAL_BLOCK_LINKS = 1;

export function isSocialPresetNetwork(
  network: SocialBlockLinkNetwork,
): network is SocialPresetNetwork {
  return (SOCIAL_PRESET_NETWORKS as readonly string[]).includes(network);
}
